<template>
    <div class="customer-profile-listing">
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <p class="text-muted">Profile</p>
                    <h2 class="listing-title d-inline-block mb-0">Loan Advisory </h2>
                        
                </b-col>
                <b-col cols="6" class="text-right ">
                    <base-button v-show="backButton" type="primary" icon size="sm" @click="close()">
                        <span class="btn-inner--text">Back / Close</span>
                    </base-button>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <CustomerProfileListingIndividualTable :is_page_advisory="true" />
            <!-- <LoanAdvisoryListing></LoanAdvisoryListing> -->
        </b-container>
    </div>
</template>
<script>
    import { Tabs, TabPane } from 'element-ui'
    import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
    import helperFunctionMixin from '@/assets/js/helperFunctionMixin.js'
    import LoanAdvisoryListing from '@/views/LoanAdvisory/LoanAdvisoryListings/LoanAdvisoryListing.vue'
    import CustomerProfileListingIndividualTable from '@/views/CustomerProfile/CustomerProfileListings/IndividualTable'

    export default {
        components: {
            LoanAdvisoryListing,
            CustomerProfileListingIndividualTable,
            RouteBreadCrumb,
            [Tabs.name]: Tabs,
            [TabPane.name]: TabPane,
        },
        mixins:[helperFunctionMixin],
        data() {
            return {
                backButton: false,
            };
        },
        created() {
            if(this.$route.params.token)
            {
                this.backButton = true;
            }
        },
        methods: {
            close() {
                if(this.$route.params.token)
                {
                    // window.location.href = "https://sas.imortgage2u.com/portal/initialSettlement/proposal/"+this.$route.params.proposal_id;
                    window.history.back();
                    window.close();
                }
                else
                {
                    this.$router.back();
                }
            }
        }
    }
</script>